import { Injectable, OnDestroy } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Injectable()
export class TranslatedPaginatorIntl extends MatPaginatorIntl implements OnDestroy {
    private destroyed = new Subject<void>();

    constructor(private translate: TranslateService) {
        super();
        this.translate.onLangChange
            .pipe(takeUntil(this.destroyed))
            .subscribe(() => this.translateLabels());

        this.translateLabels();
    }

    private translateLabels(): void {
        this.itemsPerPageLabel = this.translate.instant('PAGINATOR.ITEMS_PER_PAGE');
        this.nextPageLabel = this.translate.instant('PAGINATOR.NEXT_PAGE');
        this.previousPageLabel = this.translate.instant('PAGINATOR.PREVIOUS_PAGE');
        this.firstPageLabel = this.translate.instant('PAGINATOR.FIRST_PAGE');
        this.lastPageLabel = this.translate.instant('PAGINATOR.LAST_PAGE');

        this.getRangeLabel = (page: number, pageSize: number, length: number): string => {
            if (length === 0 || pageSize === 0) {
                return this.translate.instant('PAGINATOR.RANGE_EMPTY', { length });
            }
            const startIndex = page * pageSize;
            const endIndex = startIndex < length
                ? Math.min(startIndex + pageSize, length)
                : startIndex + pageSize;
            return this.translate.instant('PAGINATOR.RANGE_PAGE', {
                start: startIndex + 1,
                end: endIndex,
                length
            });
        };

        // Fuerza a que TODOS los mat-paginator activos re-rendericen sus textos
        this.changes.next();
    }

    ngOnDestroy(): void {
        this.destroyed.next();
        this.destroyed.complete();
    }
}